<script>
export default {
	methods: {
		getModules(moduleStatus) {
			if (!this.modules.length) {
				return [];
			}

			var modules = [];
			for (var i in this.modules) {
				var moduleFinished = true;
				for (var x in this.modules[i]) {
					for (var y in this.modules[i].resources) {
						for (var x in this.modules[i].resources[y]) {
							var questions = this.modules[i].resources[y]
								.questions;
							for (var z in questions) {
								var question = questions[z];
								if (question.user_answer.answer == "") {
									moduleFinished = false;
								}
							}
						}
					}
				}
				if (!moduleFinished) {
					if (moduleStatus == "unfinished") {
						modules.push(this.modules[i]);
					}
				} else {
					if (moduleStatus == "finished") {
						modules.push(this.modules[i]);
					}
				}
			}
			return modules;
		}
	}
};
</script>